import styled from 'styled-components';

export const Steps = styled.ul`
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    padding-left: 0 !important;
    display: flex;
    white-space: nowrap;
    align-items: center;
    list-style: none;
    margin: 0;
    justify-content: center;
    z-index: 2;
`;

export const Step = styled.li<{ $active?: boolean }>`
    color: ${(props) => props.theme.app.primary};
    opacity: ${({ $active }) => ($active ? 1 : 0.5)};
    padding: 0px 10px 0px 13px;
    font-weight: ${({ $active }) => ($active ? '600' : 'normal')};
    font-size: 13px;
    font-family: ${(props) => props.theme.app.font};
    position: relative;

    &:not(:last-child) {
        &:after {
            position: absolute;
            content: '';
            top: 11px;
            right: 0;
            background-color: #000000;
            width: 1px;
            height: 6px;
            transform: rotate(45deg);
        }
        &:before {
            position: absolute;
            content: '';
            top: 7px;
            right: 0px;
            background-color: #000000;
            width: 1px;
            height: 6px;
            transform: rotate(125deg);
        }
    }
`;
